import api from "./core";
const config = require("./serverCfg").default;

const basePath = "api/{{serverSegment}}/EForms";

export default {
  get(token) {
    return api.get(`${basePath}/${token}`);
  },
  sendLink(data) {
    return api.put(`${basePath}`, data);
  },
  sendToAll(data) {
    return api.put(`${basePath}/SendToAll`, data);
  },
  addDocument(token, data) {
    return api.put(`${basePath}/${token}/Document`, data);
  },
  editDocument(token, id, data) {
    return api.patch(`${basePath}/${token}/Document/${id}`, data);
  },
  addFormGroupDocument(token, data) {
    return api.put(`${basePath}/${token}/DocumentGroup`, data);
  },
  querySubmits(token, formId, eocId) {
    return api.get(`${basePath}/${token}/QueryResults/${formId}/${eocId}`);
  },
  queryCollections(token) {
    return api.get(`${basePath}/${token}/Collections`);
  },
  queryCollection(token, collection) {
    return api.get(`${basePath}/${token}/Collections/${collection}`);
  },
  getFormHeader(token, formId, eocId) {
    return api.get(`${basePath}/${token}/FormHeader/${formId}/${eocId}`);
  },
  getDocumentHeader(token, documentId) {
    return api.get(`${basePath}/${token}/DocumentHeader/${documentId}`);
  },
  viewUrl(token) {
    return `${config.coreBaseUrl}${basePath}/${token}/RenderDocuments`;
  }
};
